


import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import FilesUploadResult from "@/interfaces/files/files.upload.result.interface";
import TranslationsService from "@/services/translations.service";

@Component({})
export default class AppFilesUpload extends Vue {

  @Prop()
  label!: string;
  @Prop()
  extensions!: string

  @Emit('change')
  public emitChange() {
    return this.uploadResult;
  }

  public validationErrorMessage: string = '';
  public validationErrorMessages: object [] = [];
  public imagesPreview: object[] = [];
  public filesPreview: object[] = [];
  private readonly uploadResult: FilesUploadResult;
  private translations: TranslationsService = TranslationsService.getInstance();

  constructor() {
    super();
    this.uploadResult = new class implements FilesUploadResult {
      public files: File[] = [];
      public isValid: boolean = true;
    }
  }

  public handleFileUpload(event: any): void {
    const uploadedFiles = event.target.files;
    for (let i = 0; i < uploadedFiles.length; i++) {
      this.uploadResult.files.push(uploadedFiles[i]);
    }
    this.uploadResult.files = this.withoutDuplicates();
    this.validate();
    this.preparePreview();
    this.emitChange();
  }

  public removeFile(event: any): void {
    const itemToRemove = event.target.getAttribute('data-name');
    this.uploadResult.files = this.uploadResult.files.filter((e: File) => e.name !== itemToRemove)
    this.filesPreview = this.filesPreview.filter((e: any) => e.name !== itemToRemove)
    this.imagesPreview = this.imagesPreview.filter((e: any) => e.name !== itemToRemove)
    this.validate();
  }

  private withoutDuplicates(): any {
    return Array.from(new Set(this.uploadResult.files.map(file => file.name)))
        .map(name => {
          return this.uploadResult.files.find(file => file.name === name)
        })
  }

  private preparePreview(): void {
    this.filesPreview = [];
    this.imagesPreview = [];
    this.uploadResult.files.map((file: File) => {
      const isValid = this.isValid(file);
      file.type.startsWith('image/') ? this.images(file, isValid) : this.files(file, isValid);
    })
  }

  private images(image: File, isValid: boolean): void {
    this.imagesPreview.push({
      name: image.name,
      link: URL.createObjectURL(image),
      isValid: isValid
    });
  }

  private files(file: File, isValid: boolean): void {
    this.filesPreview.push({
      name: file.name,
      isValid: isValid
    });
  }

  private validate(): void {
    this.validationErrorMessages = [];
    let filesSum = 0;
    this.uploadResult.isValid = true;
    this.uploadResult.files.map((file: File) => {
      filesSum += file.size;
      if (!this.isValid(file, filesSum)) {
        this.validationErrorMessages.push({[file.name]: this.validationErrorMessage});
        this.uploadResult.isValid = false;
        this.validationErrorMessage = '';
      }
    })
  }

  private isValid(file: File, fileSum: number = 0): boolean {
    this.validationErrorMessage = '';
    this.fileErrors(file.size, fileSum);
    this.extensionsError(file.name);
    return !this.validationErrorMessage;
  }

  private extensionsError(fileName: string): void {
    if (this.extensions) {
      const allowedExtensions = this.extensions.split(',');
      const fileExtension = fileName.split('.').pop();
      if (!allowedExtensions.find(element => element === fileExtension)) {
        this.validationErrorMessage = this.translations.translation('COM_MAMMADABA_MAP_REPORT_FILE_EXTENSION_ERROR');
      }
    }
  }

  private fileErrors(currentFileSize: number, sizeSum: number) {
    const allowedFilesSize: number = 10000000;
    if (currentFileSize === 0) {
      this.validationErrorMessage = this.translations.translation('COM_MAMMADABA_MAP_REPORT_FILE_NULL_SIZE_ERROR');
    }
    if (currentFileSize > allowedFilesSize) {
      this.validationErrorMessage = this.translations.translation('COM_MAMMADABA_MAP_REPORT_FILE_TOO_LARGE_ERROR');
    }
    if (((sizeSum > allowedFilesSize) && (currentFileSize < allowedFilesSize) && (sizeSum - currentFileSize < allowedFilesSize))) {
      this.validationErrorMessage = this.translations.translation('COM_MAMMADABA_MAP_REPORT_FILE_SIZES_SUM_ERROR');
    }
    if (currentFileSize === undefined) {
      this.validationErrorMessage = this.translations.translation('COM_MAMMADABA_MAP_REPORT_BROWSER_NOT_SUPPORTED_ERROR');
    }
  }
}
